import AdminLayout from "../components/AdminLayout";
import TableNotSale from "../components/TableNotSale";

const NotSaleAdmin = () => {
  return (
    <AdminLayout title="Not For Sale" stats="default">
      <TableNotSale />
    </AdminLayout>
  );
};

export default NotSaleAdmin;
